import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";

import { LinkContext } from "../LinkProvider";
import ForexTickerTape from "./ForexTickerTape";
import LanguageMenu from "./LanguageMenu";
import MobileMenu from "./MobileMenu";

import logo from "../img/logo.svg";

function Header() {
  const { link, loginLink } = useContext(LinkContext);
  const { t } = useTranslation();
  const location = useLocation();
  const navItems = [
    { to: "/aboutus", label: t("header.about") },
    { to: "/accounts", label: t("header.accounts") },
    { to: "/markets", label: t("header.markets") },
    { to: "/support", label: t("header.support") },
  ];
  return (
    <header className="fixed left-0 top-0 z-50 w-full bg-white text-[#05193A]">
      <div className="mx-auto hidden h-[80px] max-w-[1320px] items-center px-[52px] xl:flex">
        <Link to="/" className="mr-auto block w-[83px] shrink-0">
          <img src={logo} alt="Nakamura Coin" className="h-auto w-full" />
        </Link>
        <nav className="flex items-center gap-[40px]">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`font-[Inter] text-[13px] transition-colors hover:text-[#05193A] ${location.pathname === item.to ? "font-semibold text-[#05193A]" : "text-[#2B2B2B]"}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <div className="ml-[40px] flex items-center gap-[16px]">
          <LanguageMenu />
          <a href={loginLink} className="inline-flex h-[42.386px] items-center justify-center gap-[10px] rounded-[10px] bg-[#05193A] px-[35px] py-[12px] text-center font-[Inter] text-[16px] font-light capitalize leading-normal text-white transition-colors hover:bg-[#0d2c60]">
            {t("header.login")}
          </a>
          <a href={link} className="inline-flex h-[42.386px] items-center justify-center gap-[10px] rounded-[10px] border border-[#05193A] px-[35px] py-[12px] text-center font-[Inter] text-[16px] font-light capitalize leading-normal text-[#05193A] transition-colors hover:bg-[#eef4fc]">
            {t("header.openAccount")}
          </a>
        </div>
      </div>
      <div className="mx-[20px] flex h-[60px] items-center justify-between xl:hidden">
        <Link to="/"><img src={logo} alt="Nakamura Coin" className="w-[70px]" /></Link>
        <div className="ml-auto mr-[8px]"><LanguageMenu /></div>
        <MobileMenu />
      </div>
      <div className="hidden h-[42px] overflow-hidden xl:block">
        <ForexTickerTape />
      </div>
    </header>
  );
}

export default Header;
